import { render } from "./CategoriesModal.vue?vue&type=template&id=ae9f02ce&scoped=true&ts=true"
import script from "./CategoriesModal.vue?vue&type=script&lang=ts"
export * from "./CategoriesModal.vue?vue&type=script&lang=ts"

import "./CategoriesModal.vue?vue&type=style&index=0&id=ae9f02ce&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae9f02ce"]])

export default __exports__